import * as React from 'react';
import { connect, Dispatch } from 'react-redux';

import { Action } from '../../actions';
import { removeInternalMarketerProductAccessAction } from '../../actions/marketer/internal/removeInternalMarketerProductAccess';
import { Loader } from '../../components/Loader/Loader';
import {
    MarketerProductRemoveCell,
    MarketerProductRemoveCellProps
} from '../../components/MarketerProductRemoveCell/MarketerProductRemoveCell';
import { AccessRights } from '../../typings/common';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type OwnProps = {
    id: string;
    isRemoving: boolean;
};
type StateProps = TStateProps<MarketerProductRemoveCellProps, OwnProps> & {
    accessRights: AccessRights;
};
type DispatchProps = TDispatchProps<MarketerProductRemoveCellProps, OwnProps>;
type MergedProps = StateProps & DispatchProps & OwnProps;

const mapStateToProps = (state: State): StateProps => ({
    accessRights: state.commonData.accessRights
});

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => ({
    removeMarketerProduct: () => dispatch(removeInternalMarketerProductAccessAction(ownProps.id))
});

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: OwnProps): MergedProps => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps
});

export const MarketerProductRemoveCellContainer = connect<StateProps, DispatchProps, OwnProps, MergedProps>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)((props: MergedProps) => {
    if (!props.accessRights.canEditInternalAdManagers) {
        return null;
    }

    if (props.isRemoving) {
        return <Loader size={'xs'} />;
    }

    return <MarketerProductRemoveCell removeMarketerProduct={props.removeMarketerProduct} />;
});
